import {TokenIterator} from "./tokenIterator.mjs";
import {NodeIterator} from "./nodeIterator.mjs";
import {NodeName} from "../flavour/openlexia/nodeName.mjs";
import {Node} from "./node.mjs";

export class NodeTreeBuilder{

    constructor(nodeRules) {
        if(nodeRules.length == 0) throw new Error('node rules cannot be empty')
        this.nodeRules = nodeRules
    }


    buildNodeTree(tokens) {
        if(tokens.length == 0) return null

        const rootNode = new Node(NodeName.ROOT, null, null, null)
        const tokenIterator = new TokenIterator(structuredClone(tokens))
        const nodeIterator = new NodeIterator(rootNode)

        // visit tokens to creat node tree
        while (tokenIterator.token()) {
            let tokenIndex = tokenIterator.index
            for(const rule of this.nodeRules) {
                rule.consume(tokenIterator, nodeIterator)

                // IF token was consumed
                if(tokenIndex !== tokenIterator.index) break;
            }
        }

        // cancel unclosed node and treat them as text
        nodeIterator.openNodes.forEach((node) => {
            if(node) node.onEdnOfMarkup()
        })

        return rootNode
    }

}
